import DraftHomePage from './DraftHomePage';

export default function HomePage() {
  return <DraftHomePage />;
}
